import { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Container,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SystemDataService from "../../../services/KangarooServices/SystemDataService";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
// Validation Schema
const PrivacySchema = Yup.object().shape({
  heading: Yup.string().required("heading is required"),
  content: Yup.string().required("Privacy content is required"),
});

const PrivacyForm = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [defaultData, setDefaultData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await SystemDataService.getDetail(id);
      setDefaultData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [id]);
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (id) {
        const response = await SystemDataService.update(id, values);
        toast.success("Updated successfull");
      } else {
        const response = await SystemDataService.create(values);
        toast.success("Created successfull");
      }
      navigate("/system-setup");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Pages List" pageTitle="Pages" />

        <Formik
          initialValues={{
            heading: defaultData?.heading || "Privacy Policy",
            content: defaultData?.content || "",
          }}
          validationSchema={PrivacySchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <ModalBody>
                {/* TITLE */}
                <FormGroup>
                  <Label>Heading</Label>
                  <Field
                    name="heading"
                    className="form-control"
                    placeholder="Enter privacy page heading"
                   
                  />
                  {errors.heading && touched.heading && (
                    <div className="text-danger small">{errors.heading}</div>
                  )}
                </FormGroup>

                {/* CONTENT */}
                <FormGroup>
                  <Label>Content</Label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={values.content}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setFieldValue("content", data);
                    }}
                  />
                  {errors.content && touched.content && (
                    <div className="text-danger small">{errors.content}</div>
                  )}
                </FormGroup>
              </ModalBody>

              <ModalFooter>
                <button
                  // color="secondary"
                  className="btn btn-danger me-2"
                  onClick={() => navigate("/system-setup")}
                >
                  Cancel
                </button>
                <button 
                  // color="primary" 
                  type="submit"
                  className="btn btn-success"
                  disabled={loading}>
                  {loading ? <Spinner size="sm" /> : "Save"}
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

export default PrivacyForm;
